<template>
  <div class="form-group">
    <label>
      <span class="title">{{ title }}</span>
      <span class="required" v-if="required">*</span>
      <Tip :field="field" :formName="formName" />
    </label>
    <div class="inner-addon right-addon">
      <i v-if="notifications.length > 0 && formDirty" class="required glyphicon fas fa-exclamation-triangle"></i>

      <textarea :disabled="disabled" rows="4" cols="50" type="text" :placeholder="placeholder" v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
        :class="{ 'is-invalid': notifications.length > 0 && formDirty }">
      </textarea>
    </div>

    <div v-if="formDirty">
      <div v-for="message in notifications" :key="message">
        <span class="invalid">{{ message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Tip from "../shared/Tip.vue";
import { mapState, mapMutations } from "vuex";

export default {
  components: { Tip },
  name: "TextArea",
  props: {
    title: String,
    field: String,
    placeholder: String,
    disabled: Boolean,
    formName: String,
    required: Boolean,
    maxLength: Number,
    value: String,
    changed: Function,
  },
  data() {
    return {
      notifications: [],
      formDirty: false,
    };
  },
  created() {
    this.validate();
  },
  methods: {
    ...mapMutations("validation", [
      "addValidation",
      "removeValidation",
      "updateFormDirty",
    ]),
    validate() {
      this.notifications = [];

      if (this.required && this.value.length == 0) {
        var message = `${this.title} não pode ser vazio!`;
        this.notifications.push(message);
      }

      if (this.maxLength > 0) {
        if (this.value.length > this.maxLength) {
          var message = `Máximo de ${this.maxLength} caracteres!`;
          this.notifications.push(message);
        }
      }
    },
  },
  computed: {
    ...mapState("validation", ["resetForm", "validations"]),
  },
  watch: {
    value() {
      this.validate();
      this.formDirty = true;
      this.updateFormDirty(true);
      if (this.changed) this.changed();
    },
    notifications() {
      let self = this;
      this.notifications.forEach(function (notification) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
          notification: notification,
        };
        self.addValidation(obj);
      });

      if (this.notifications.length == 0) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
        };
        self.removeValidation(obj);
      }
    },
    resetForm: {
      handler(form) {
        if (form.name == this.formName) this.formDirty = false;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
textarea {
  width: 100%;
  border: 1px #DBDEE0 solid;
  border-radius: 5px;
  color: #35495E;
  padding-left: 10px;
  padding-right: 10px;
  font-weight: normal !important;
  font-size: 14px;
}

textarea:disabled {
  background-color: white !important;
  opacity: 0.5;
}


.success {
  color: #94aa2a;
  font-size: 14px;
}

.invalid {
  color: #f0134d;
  font-size: 14px;
}
</style>
